export const getNativeAppPlatform = (): string | null => {
    if (typeof window === 'undefined' || !window.KNOVIGATOR_IS_MOBILE) {
        return null
    }

    const nativePlatform = window.KNOVIGATOR_NATIVE_APP_INFO?.platform
    if (nativePlatform) {
        return nativePlatform
    }

    if (typeof navigator === 'undefined') {
        return null
    }

    if (/\b(iPhone|iPad|iPod)\b/i.test(navigator.userAgent)) {
        return 'ios'
    }

    if (/\bAndroid\b/i.test(navigator.userAgent)) {
        return 'android'
    }

    return null
}

export const isNativeApp = (): boolean => getNativeAppPlatform() !== null

export const isNativeIOSApp = (): boolean => getNativeAppPlatform() === 'ios'

export type PreparedExternalCheckout = {
    requiresPopup: boolean
    popup: WindowProxy | null
}

// Android's WebView only permits window.open during the tap. Reserve its blank window before
// the async checkout-session request, then navigate that window when Stripe returns its URL.
export const prepareExternalCheckout = (): PreparedExternalCheckout => {
    const requiresPopup = getNativeAppPlatform() === 'android'
    return { requiresPopup, popup: requiresPopup ? window.open('', '_blank') : null }
}

export const openExternalCheckout = (url: string, prepared: PreparedExternalCheckout): boolean => {
    if (prepared.requiresPopup) {
        if (!prepared.popup) return false
        prepared.popup.location.href = url
        return true
    }
    window.location.assign(url)
    return true
}

export const cancelExternalCheckout = (prepared: PreparedExternalCheckout): void => {
    prepared.popup?.close()
}
